import { render } from "./SessionSection.vue?vue&type=template&id=2eccfb60&scoped=true"
import script from "./SessionSection.vue?vue&type=script&lang=js"
export * from "./SessionSection.vue?vue&type=script&lang=js"

import "./SessionSection.vue?vue&type=style&index=0&id=2eccfb60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eccfb60"]])

export default __exports__